<div class="min-h-screen flex flex-col bg-background text-text">
  <header
    class="backdrop-blur-sm sticky top-0 z-30 h-16 flex items-center px-6 border-b border-border"
  >
    <div class="w-full flex justify-between items-center">
      <div class="flex items-center gap-8">
        <a routerLink="/" class="text-2xl sm:text-3xl font-bold brand-gradient"
          >Haulverse</a
        >

        <nav class="hidden md:flex items-center gap-6">
          <a
            routerLink="/features"
            routerLinkActive="text-primary font-semibold"
            class="nav-link text-muted hover:text-text cursor-pointer transition-colors"
            >Features</a
          >
          <a
            routerLink="/pricing"
            routerLinkActive="text-primary font-semibold"
            class="nav-link text-muted hover:text-text cursor-pointer transition-colors"
            >Pricing</a
          >
          <a
            routerLink="/contact"
            routerLinkActive="text-primary font-semibold"
            class="nav-link text-muted hover:text-text cursor-pointer transition-colors"
            >Contact</a
          >
          <a
            routerLink="/about"
            routerLinkActive="text-primary font-semibold"
            class="nav-link text-muted hover:text-text cursor-pointer transition-colors"
            >About</a
          >
        </nav>
      </div>
      <div class="flex items-center gap-4">
        <a
          routerLink="/auth/login"
          class="nav-link hidden sm:block cursor-pointer text-muted hover:text-text transition-colors"
          >Sign In</a
        >
        <!-- Only show the signup button on screens medium and up -->
        <app-button
          route="/auth/signup"
          class="hidden! md:flex!"
          variant="primary"
          >Sign Up Free</app-button
        >
        <app-theme-toggle></app-theme-toggle>

        <!-- Mobile Menu Button -->
        <button
          (click)="toggleMobileMenu()"
          class="md:hidden p-2 z-50 text-text"
        >
          @if (!isMobileMenuOpen()) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M4 6h16M8 12h12M12 18h8"
            />
          </svg>
          } @else {
          <lucide-icon name="x" class="h-6 w-6"></lucide-icon>
          }
        </button>
      </div>
    </div>
  </header>

  <!-- Mobile Menu Overlay -->
  @if (isMobileMenuOpen()) {
  <div
    class="fixed inset-0 bg-background z-20 md:hidden"
    (click)="toggleMobileMenu()"
    (keydown.enter)="toggleMobileMenu()"
    tabindex="0"
  >
    <nav
      (click)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      tabindex="0"
      class="flex flex-col items-center justify-center h-full gap-8 text-center"
    >
      <a
        (click)="toggleMobileMenu()"
        routerLink="/features"
        class="text-xl font-semibold text-text"
        >Features</a
      >
      <a
        (click)="toggleMobileMenu()"
        routerLink="/pricing"
        class="text-xl font-semibold text-text"
        >Pricing</a
      >
      <a
        (click)="toggleMobileMenu()"
        routerLink="/contact"
        class="text-xl font-semibold text-text"
        >Contact</a
      >
      <a
        (click)="toggleMobileMenu()"
        routerLink="/about"
        class="text-xl font-semibold text-text"
        >About</a
      >
      <div class="w-48 border-t border-border my-4"></div>
      <a
        (click)="toggleMobileMenu()"
        routerLink="/auth/login"
        class="text-xl font-semibold text-text"
        >Sign In</a
      >
      <app-button
        (click)="toggleMobileMenu()"
        routerLink="/auth/signup"
        class="cursor-pointer"
        variant="primary"
        >Sign Up Free</app-button
      >
    </nav>
  </div>
  }

  <main class="flex-1">
    <app-toast-stack />
    <router-outlet></router-outlet>
  </main>

  <!-- Public Footer -->
  <footer class="border-t border-border bg-surface py-12 px-6">
    <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
      <div class="space-y-4">
        <a routerLink="/" class="text-2xl font-bold brand-gradient">Haulverse</a>
        <p class="text-sm text-muted leading-relaxed">
          The Operating System for Freight Fleets. Streamlining dispatches, rate cons, invoicing, and compliance in one place.
        </p>
      </div>

      <div>
        <h4 class="font-bold text-sm text-text mb-4 uppercase tracking-wider">Product</h4>
        <ul class="space-y-2 text-sm text-muted">
          <li><a routerLink="/features" class="hover:text-text transition-colors">Features</a></li>
          <li><a routerLink="/pricing" class="hover:text-text transition-colors">Pricing</a></li>
          <li><a routerLink="/auth/login" class="hover:text-text transition-colors">Sign In</a></li>
          <li><a routerLink="/auth/signup" class="hover:text-text transition-colors">Sign Up Free</a></li>
        </ul>
      </div>

      <div>
        <h4 class="font-bold text-sm text-text mb-4 uppercase tracking-wider">Company & Support</h4>
        <ul class="space-y-2 text-sm text-muted">
          <li><a routerLink="/about" class="hover:text-text transition-colors">About Us</a></li>
          <li><a routerLink="/contact" class="hover:text-text transition-colors">Contact Us</a></li>
          <li><a routerLink="/support" class="hover:text-text transition-colors">Help Center & Support</a></li>
          <li><a href="mailto:info@haulverse.com" class="hover:text-text transition-colors">info@haulverse.com</a></li>
        </ul>
      </div>

      <div>
        <h4 class="font-bold text-sm text-text mb-4 uppercase tracking-wider">Legal & Mobile</h4>
        <ul class="space-y-2 text-sm text-muted">
          <li><a routerLink="/privacy" class="hover:text-text transition-colors">Privacy Policy</a></li>
          <li><a routerLink="/terms" class="hover:text-text transition-colors">Terms of Service</a></li>
          <li><span class="text-xs text-muted">iOS & Android Driver Apps</span></li>
        </ul>
      </div>
    </div>

    <div class="max-w-7xl mx-auto border-t border-border/50 mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-muted">
      <p>© {{ newDate.getFullYear() }} Haulverse LLC. All rights reserved.</p>
      <p>The Operating System for Freight Fleets</p>
    </div>
  </footer>
</div>
